function onDocumentReady() {
	// video modal
	let els = document.querySelectorAll('.modal-open-button');
	[...els].map(initializePhotoCarousel);

	//down arrow
	let arrow = jQuery('#hero-down-arrow');

	if (arrow.length > 0) {
		arrowFunction(arrow); // arrowFunction, get it? See what I did there? I'll see myself out.
	}
}

function initializePhotoCarousel(el) {
	jQuery(el).magnificPopup({
		type: 'inline',
	});
}

function arrowFunction(el) {
	el.click(function() {
		let target = el.closest('section').parent('section').next('section').children('section'), // because sections on sections on sections
			targetMargin = el.closest('section').parent('section').css('margin-bottom'),
			headerHeight = jQuery('header nav').height();

		// include margin bottom from partent section
		headerHeight = headerHeight + parseInt(targetMargin);

		if (target) {
			scrollToElement(target, headerHeight);
		}

		return !target;
	});
}

function scrollToElement(element, headerHeight) {

	if (!element) {
		return false;
	}

	let el = jQuery(element);
	if (el.length === 0) {
		return false;
	}

	scrollToY(el.offset().top - headerHeight);
}

function scrollToTop() {
	scrollToY(0);
}

function scrollToY(y) {
	jQuery('html, body').animate({scrollTop: y});
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
